import { ENVIRONMENT } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { endpoints } from './endpoints';

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (ENVIRONMENT.mockEnabled) {
      for (const endpoint of endpoints) {
        if (
          request.url === endpoint.path &&
          request.method === endpoint.method &&
          endpoint.enabled
        ) {
          return of(
            new HttpResponse({
              status: endpoint.status,
              body: endpoint.response,
            })
          );
        }
      }
    }
    return next.handle(request);
  }
}
